import { render, staticRenderFns } from "./paymentKoPage.vue?vue&type=template&id=2e32a51a"
import script from "./paymentKoPage.vue?vue&type=script&lang=ts"
export * from "./paymentKoPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports